module.exports = __webpack_public_path__ + "media/src/img/payment/elkart-90957a21176dae1f6c14f9909b081a0e.svg";